import { createSelector } from 'reselect';

export interface AuthState {
  loggedIn: boolean;
  loading: boolean;
  error: string;
  user: any;
}

export const initialState: AuthState = {
  loggedIn: false,
  error: '',
  loading: false,
  user: {},
};

const getAuth = ({ auth }: any): AuthState => auth;

export const authSelectors = {
  getLoggedIn: createSelector(
    [getAuth],
    auth => auth.loggedIn,
  ),
  getError: createSelector(
    [getAuth],
    auth => auth.error,
  ),
  getLoading: createSelector(
    [getAuth],
    auth => auth.loading,
  ),
  getUserRole: createSelector(
    [getAuth],
    auth => auth.user.role,
  ),
  getUser: createSelector(
    getAuth,
    auth => auth.user,
  ),
};



// WEBPACK FOOTER //
// ./src/store/auth/selectors.ts